import React, { useState } from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useAvailableRewards, useRedeemReward, useCustomerLookup } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Search, Gift, CheckCircle2 } from 'lucide-react';
export function LoyaltyRedemptionPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const [phoneSearch, setPhoneSearch] = useState('');
  const [activePhone, setActivePhone] = useState('');
  const {
    customer,
    loading: customerLoading
  } = useCustomerLookup(activePhone, restaurant.restaurant_id);
  const {
    rewards,
    loading: rewardsLoading,
    refetch
  } = useAvailableRewards(activePhone, restaurant.restaurant_id);
  const {
    redeem,
    loading: redeeming
  } = useRedeemReward();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (phoneSearch.length >= 8) {
      setActivePhone(phoneSearch);
    }
  };
  const handleRedeem = async (rewardId: string) => {
    if (window.confirm('¿Estás seguro de redimir este beneficio? Esta acción no se puede deshacer.')) {
      const result = await redeem(rewardId);
      if (result.success) {
        alert('¡Beneficio redimido con éxito!');
        refetch(); // Refresh rewards list
      } else {
        alert('Error al redimir el beneficio: ' + result.error);
      }
    }
  };
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-5095" data-mp="37ju2gapxh81h">
      <div className="p-6 max-w-3xl mx-auto space-y-6" data-id="element-5096" data-mp="3cjovokx6e9pp">
        <div data-id="element-5097" data-mp="3hchyv4czx9zo">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-5098" data-mp="3hd1gejyqhwd6">
            Redimir Beneficios
          </h1>
          <p className="text-gray-500" data-id="element-5099" data-mp="2jvj4bfbm9mgw">
            Busca a un cliente por su número de teléfono para ver y redimir sus
            beneficios.
          </p>
        </div>

        <Card className="p-6" data-id="element-5100" data-mp="2guhfjpawo2v6">
          <form onSubmit={handleSearch} className="flex gap-3" data-id="element-5101" data-mp="2gtog79ea0fn2">
            <div className="flex-1" data-id="element-5102" data-mp="2bwfxn7p7u9la">
              <Input type="tel" placeholder="Número de teléfono (ej. 88888888)" value={phoneSearch} onChange={e => setPhoneSearch(e.target.value)} className="w-full" data-id="element-5103" data-mp="2bv4qqz0h4lpy" />
            </div>
            <Button type="submit" disabled={phoneSearch.length < 8} data-id="element-5104" data-mp="1xx6h26x3ldgs">
              <Search className="w-4 h-4 mr-2" data-id="element-5105" data-mp="1sxabw4cnzfzn" />
              Buscar
            </Button>
          </form>
        </Card>

        {activePhone && <div className="space-y-6" data-id="element-5106" data-mp="27vw228kaje19">
            {customerLoading || rewardsLoading ? <div className="text-center py-12 text-gray-500" data-id="element-5107" data-mp="22uf2qhhgfzms">
                Buscando información...
              </div> : !customer ? <Card className="p-12 text-center" data-id="element-5108" data-mp="3ean80qo9tp25">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5109" data-mp="3e9vahab45h98">
                  <Search className="w-8 h-8 text-gray-400" data-id="element-5110" data-mp="3lsl4nulct5ny" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-5111" data-mp="3quk79299ryju">
                  Cliente no encontrado
                </h3>
                <p className="text-gray-500" data-id="element-5112" data-mp="3cvkjdwtkznoq">
                  No hay ningún cliente registrado con el número {activePhone}.
                </p>
              </Card> : <>
                <Card className="p-6 bg-brand-charcoal text-white" data-id="element-5113" data-mp="8hcc8tcks8d4">
                  <div className="flex items-center gap-4" data-id="element-5114" data-mp="ddks68ylk5lc">
                    <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center text-2xl font-bold" data-id="element-5115" data-mp="3vsvgbarqq510">
                      {customer.name ? customer.name.charAt(0).toUpperCase() : '?'}
                    </div>
                    <div data-id="element-5116" data-mp="w4c2pdubm21b">
                      <h2 className="text-xl font-bold" data-id="element-5117" data-mp="w5m1k58zze90">
                        {customer.name || 'Cliente sin nombre'}
                      </h2>
                      <p className="text-white/70" data-id="element-5118" data-mp="34jadr0bps2za">{customer.phone}</p>
                    </div>
                  </div>
                </Card>

                <div data-id="element-5119" data-mp="2ump94g3lwtvz">
                  <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-5120" data-mp="2uo8rqdcqjh0x">
                    <Gift className="w-5 h-5 text-brand-charcoal" data-id="element-5121" data-mp="2qmx4ufl8x9wf" />
                    Beneficios Disponibles ({rewards.length})
                  </h3>

                  {rewards.length === 0 ? <Card className="p-8 text-center text-gray-500" data-id="element-5122" data-mp="3ie33erlbizjl">
                      Este cliente no tiene beneficios disponibles en este
                      momento.
                    </Card> : <div className="grid gap-4" data-id="element-5123" data-mp="39khnh4xf3c8l">
                      {rewards.map(reward => <Card key={reward.id} className="p-4 flex items-center justify-between gap-4 border-l-4 border-l-brand-charcoal" data-id="element-5124" data-mp="9yjdo2juvz9a">
                          <div data-id="element-5125" data-mp="1nvmbxada3vp6">
                            <h4 className="font-bold text-gray-900 text-lg" data-id="element-5126" data-mp="1srun6cocv4r2">
                              {reward.reward_name}
                            </h4>
                            <p className="text-sm text-gray-500" data-id="element-5127" data-mp="1wwap62uuls10">
                              Válido hasta:{' '}
                              {new Date(reward.expires_at).toLocaleDateString()}
                            </p>
                          </div>
                          <Button onClick={() => handleRedeem(reward.id)} disabled={redeeming} data-id="element-5128" data-mp="2bpxg32k0xlu5">
                            Redimir
                          </Button>
                        </Card>)}
                    </div>}
                </div>
              </>}
          </div>}
      </div>
    </AdminLayout>;
}